// extracted by mini-css-extract-plugin
export default {"wrapper":"As-z","response":"Bs-z","error":"Cs-z","disabled":"Ds-z","buttons":"Es-z","feedbackQuestionSection":"Fs-z","yesNoWrapper":"Gs-z"};